import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-historico-proprietario-simplificado',
  templateUrl: './consulta-historico-proprietario-simplificado.component.html',
  styleUrls: ['./consulta-historico-proprietario-simplificado.component.scss']
})
export class ConsultaHistoricoProprietarioSimplificadoComponent implements OnInit {


  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    this.setTipoPessoa();

  }

  setTipoPessoa() {
    if (this.consulta && this.consulta.lista instanceof Array) {
      this.consulta.lista.forEach(p => p.tipoPessoa = p.cgcCpf ? (p.cgcCpf.size > 11 ? "CNPJ" : "CPF") : "CPF/CNPJ")
    }
  }

  getMsg() {
    if (this.consulta && this.consulta.lista != null && this.consulta.lista.length == 0) {
      return { msg: 'NADA CONSTA', status: 'info' }
    } else {
      return { msg: null, status: 'info' };
    }
  }
}
